const initialLoadingComplete = 'breakwater:initial-loading-complete'

export const hasInitialLoadingCover = () => typeof document !== 'undefined' && !!document.getElementById('initial-app-loading')

export const subscribeToInitialLoading = listener => {
  window.addEventListener(initialLoadingComplete, listener)
  return () => window.removeEventListener(initialLoadingComplete, listener)
}

// Keep the HTML loader alive while React hands off between its startup gates.
// Watching the committed UI also releases the cover for sign-in and error pages.
export const startInitialLoading = () => {
  const loader = document.getElementById('initial-app-loading')
  const root = document.getElementById('root')
  if (!loader || !root) return () => {}

  let frame = null
  let finished = false
  const stop = () => {
    observer.disconnect()
    if (frame !== null) window.cancelAnimationFrame(frame)
    frame = null
  }
  const checkReady = () => {
    if (finished) return
    if (frame !== null) window.cancelAnimationFrame(frame)
    // Let redirects and new loading gates commit before revealing the page.
    frame = window.requestAnimationFrame(() => {
      frame = null
      if (!root.hasChildNodes() || root.querySelector('[data-app-loading]')) return
      finished = true
      stop()
      loader.remove()
      root.removeAttribute('data-app-booting')
      root.removeAttribute('aria-hidden')
      root.removeAttribute('inert')
      window.dispatchEvent(new Event(initialLoadingComplete))
    })
  }
  const observer = new MutationObserver(checkReady)
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-app-loading'],
  })
  checkReady()
  return stop
}
